// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CurrencyMinor from "../../../../../../library/data-source/country-currency/CurrencyMinor.bs.js";
import * as Date$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/date/Date.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CampaignModificationType from "../entity/CampaignModificationType.bs.js";
import * as CampaignModificationStatus from "../entity/CampaignModificationStatus.bs.js";
import * as CampaignModificationAPIModel from "../api-model/CampaignModificationAPIModel.bs.js";

function decodeKeyDetails(param) {
  var creation_info = param.creation_info;
  var status = param.status;
  var time = status.approval_time;
  var tmp;
  if (time !== undefined) {
    var person = status.approver;
    tmp = person !== undefined ? ({
          approved_on: Timestamp$Catalyst.make(time),
          first_name: person.first_name,
          last_name: person.last_name
        }) : Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "Approver details are missing", undefined), undefined);
  } else {
    tmp = undefined;
  }
  return {
          name: param.name,
          external_id: param.external_id,
          start_date: Timestamp$Catalyst.make(param.start_instant),
          end_date: Belt_Option.mapWithDefault(param.end_instant, undefined, (function (d) {
                  return Caml_option.some(Timestamp$Catalyst.make(d));
                })),
          creation_info: {
            first_name: creation_info.creator.first_name,
            last_name: creation_info.creator.last_name,
            creation_time: Timestamp$Catalyst.make(creation_info.creation_time)
          },
          approver_info: tmp,
          status: CampaignModificationStatus.fromString(status.campaign_status)
        };
}

function decodeDelta(delta) {
  return {
          base_details: {
            base_fare_delta: CurrencyMinor.toBase(delta.base_fare_delta.minor_amount),
            free_duration_delta: delta.free_duration_delta,
            waiting_rate_per_min_delta: CurrencyMinor.toBase(delta.waiting_rate_per_minute_delta.minor_amount),
            free_kms_delta: delta.free_distance_pricing_delta.free_kms_delta,
            free_km_price_per_min_delta: CurrencyMinor.toBase(delta.free_distance_pricing_delta.price_per_min_delta.minor_amount)
          },
          slab_details: List.map((function (slab) {
                  return {
                          slab_km: slab.slab_km,
                          price_per_min: CurrencyMinor.toBase(slab.price_per_min.minor_amount),
                          price_per_km: CurrencyMinor.toBase(slab.price_per_km.minor_amount)
                        };
                }), delta.distance_time_pricing)
        };
}

function decodeEligibilityRules(rules) {
  return {
          start_time: Date$Catalyst.make(rules.start_time, "HH:mm:ss.SSS"),
          end_time: Date$Catalyst.make(rules.end_time, "HH:mm:ss.SSS"),
          repeat_days: rules.repeat_on_days,
          pick_up_zone: rules.pickup_zone_ids,
          pick_up_cluster: rules.pickup_cluster_ids,
          drop_zone: rules.drop_zone_ids,
          drop_cluster: rules.drop_cluster_ids
        };
}

function execute(json) {
  var modifications = DeccoUtils$Catalyst.resolveResult(CampaignModificationAPIModel.modification_list_decode(json), "CampaignModificationEntityMapper.re");
  return List.map((function (modification) {
                var modification_info = Belt_List.get(modification.modification, 0);
                if (modification_info === undefined) {
                  return Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "modification list cannot be empty", undefined), undefined);
                }
                var match = CampaignModificationType.fromString(modification_info.modification);
                if (match) {
                  var match$1 = List.length(modification.modification);
                  if (match$1 === 0) {
                    return Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "modification list is empty", undefined), undefined);
                  }
                  if (match$1 !== 1) {
                    return Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "simple modification list containing more than one modification", undefined), undefined);
                  }
                  var modification$1 = Belt_List.get(modification.modification, 0);
                  var delta = modification$1.delta;
                  return {
                          TAG: /* Simple */1,
                          key_details: decodeKeyDetails(modification),
                          control_details: delta !== undefined ? decodeDelta(delta) : Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "delta key missing from", undefined), undefined),
                          eligibility_rules: decodeEligibilityRules(modification.eligibility_config)
                        };
                } else {
                  var match$2 = List.length(modification.modification);
                  if (match$2 !== 0) {
                    return {
                            TAG: /* AB */0,
                            key_details: decodeKeyDetails(modification),
                            test_control_details: List.map((function (modification) {
                                    var delta = modification.control_delta;
                                    var delta$1 = modification.test_delta;
                                    var test_sample_criteria = modification.test_sample_criteria;
                                    return {
                                            control_details: delta !== undefined ? decodeDelta(delta) : Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "control_delta key missing", undefined), undefined),
                                            test_details: delta$1 !== undefined ? decodeDelta(delta$1) : Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "test_delta key missing", undefined), undefined),
                                            test_ids: test_sample_criteria !== undefined ? test_sample_criteria.customer_id_buckets : Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "test_sample_criteria missing", undefined), undefined)
                                          };
                                  }), modification.modification),
                            eligibility_rules: decodeEligibilityRules(modification.eligibility_config)
                          };
                  } else {
                    return Curry._1(ErrorUtils$Catalyst.raiseError("CampaignModificationEntityMapper.re", "modification list is empty", undefined), undefined);
                  }
                }
              }), modifications.modification_campaigns);
}

export {
  execute ,
  
}
/* Date-Catalyst Not a pure module */
